export default "__VITE_ASSET__Bcz0VQEE__"